import { render } from "./Layout.vue?vue&type=template&id=f38cfd96"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"
script.render = render

export default script